import { render, staticRenderFns } from "./MatchLiveAwsPanel.vue?vue&type=template&id=12b83a04"
import script from "./MatchLiveAwsPanel.vue?vue&type=script&lang=js"
export * from "./MatchLiveAwsPanel.vue?vue&type=script&lang=js"
import style0 from "./MatchLiveAwsPanel.vue?vue&type=style&index=0&id=12b83a04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports